var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../Fct/createPlugin';
import { FctValue } from '../../../Fct/generics';
export var GetPercent = createPlugin({
    protocol: 'FUNCTIONS',
    type: 'GETTER',
    method: 'getPercent',
    name: 'getPercent',
    flowType: 'OFFCHAIN_ONLY',
    getParams: function (_a) { return ({
        input: {
            percent: new FctValue({ required: false, decimals: 2 }),
            minPercent: new FctValue({ required: false, decimals: 2 }),
            maxPercent: new FctValue({ required: false, decimals: 2 }),
            tick: new FctValue({ required: false, decimals: 2 }),
            methodParams: {},
        },
        output: {},
    }); },
    calculateValuesOnUserInput: function (_a) {
        var input = _a.input;
        var parsePercent = function () { return __awaiter(void 0, void 0, void 0, function () {
            var percent, minPercent, maxPercent, tick, min, max, tickStr, options, start_1, stop_1, tickNum, i, name_1, percentValue, error, percentValueNum, start, stop;
            return __generator(this, function (_a) {
                percent = input.percent, minPercent = input.minPercent, maxPercent = input.maxPercent, tick = input.tick;
                min = minPercent.value && typeof minPercent.value === 'string' ? minPercent.value : '0';
                max = maxPercent.value && typeof maxPercent.value === 'string' ? maxPercent.value : '20000';
                tickStr = tick.value;
                if (tickStr && typeof tickStr === 'string') {
                    options = [];
                    start_1 = Number(min);
                    stop_1 = Number(max);
                    tickNum = Number(tickStr);
                    if (!tickNum) {
                        percent.options = [];
                    }
                    else {
                        for (i = start_1; i <= stop_1; i += tickNum) {
                            if (i <= stop_1) {
                                name_1 = "".concat(String(i / 100), " %");
                                options.push({
                                    value: String(i),
                                    name: name_1,
                                });
                            }
                        }
                        percent.options = options;
                    }
                }
                else {
                    percent.options = [];
                }
                percentValue = percent.value;
                error = undefined;
                if (!percentValue || typeof percentValue !== 'string')
                    return [2 /*return*/, {
                            params: {},
                            error: undefined,
                        }];
                percentValueNum = Number(percentValue);
                start = Number(min);
                stop = Number(max);
                if (percentValueNum < start) {
                    percent.value = min;
                    error = "value should be greater equal ".concat(Number(min) / 100, "%");
                }
                if (percentValueNum > stop) {
                    percent.value = max;
                    error = "value should be less equal ".concat(Number(max) / 100, "%");
                }
                return [2 /*return*/, {
                        params: {},
                        error: error,
                    }];
            });
        }); };
        return {
            get: parsePercent,
            depParamKeys: ['percent', 'minPercent', 'maxPercent', 'tick'],
        };
    },
});
